import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { GlobalModule } from './global/global.module';
import { HomeComponent } from './home/home.component';
import { PokemonComponent } from './pokemon/pokemon.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent, HomeComponent, PokemonComponent],
  imports: [BrowserModule, AppRoutingModule, HttpClientModule, GlobalModule, SharedModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
